module.exports = __webpack_public_path__ + "static/img/sportGame2.5699c69.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/sportGame2.png
// module id = u6nr
// module chunks = 3